import * as React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalChildStyle } from './modal';
import { style } from 'typestyle';
import { colorBrand, colorContrast } from '../theme/color';
import {important, px, rgb} from 'csx';
import { TextNoOrphan } from './text-no-orphan';
import { FormOnboarding, FormOnboardingFields } from './form-onboarding';
import { resetAnchorStyles } from '../theme/reset';
import { FieldValues } from '../types/form';
import { UIHeroGenre } from '../types/ui';
import { UserModel } from '../modules/user/model';
import { AuthController } from '../modules/auth/controller';

export interface OnboardingModalModel {
  show: boolean;
  saving: boolean;
  error: string;
  defaultValues?: FieldValues<FormOnboardingFields>;
  genres: Array<UIHeroGenre>;
}

export interface OnboardingModalProps {
  onSubmit(fields: FormOnboardingFields): void;
  onLogout: AuthController['logout'];
  onClickLink(event: React.MouseEvent<any>): void;
  model: OnboardingModalModel;
  user: UserModel;
  i18n?: {
    title: string;
    strap: string;
    tandc: string;
  };
}

const DEFAULT_I18N = {
  title: 'Nearly there!',
  strap: 'We just need a few more details from you in order to work out your price band',
  tandc: 'View terms and conditions',
};

@observer
export class OnboardingModal extends React.Component<OnboardingModalProps, {}> {
  render() {
    const { onSubmit, onLogout, onClickLink, model, user, i18n = DEFAULT_I18N } = this.props;

    const isObject = (obj: any) => typeof obj === 'object' && obj !== null;
    const channelName = isObject(user) && isObject(user.channel) ? user.channel.name : 'Unknown';

    return (
      <Modal show={model.show} onRequestClose={() => void 0}>
        {model.show && (
          <div className={OnboardingModal.styles.container}>
            <h3>
              <TextNoOrphan value={i18n.title} />
            </h3>
            <p className={OnboardingModal.styles.switchLink}>
              You’re ready to licence tracks for the channel <strong>{channelName}</strong>. Want to licence for another
              channel?
              <br />
              <a href="#" onClick={() => onLogout(false, false, true)}>
                Switch Account
              </a>
            </p>
            <p>{i18n.strap}</p>
            <FormOnboarding
              onSubmit={onSubmit}
              error={model.error}
              saving={model.saving}
              defaultValues={model.defaultValues}
              genres={model.genres}
            />
            <a className={OnboardingModal.styles.link} href="/terms-and-conditions" onClick={onClickLink}>
              {i18n.tandc}
            </a>
          </div>
        )}
      </Modal>
    );
  }

  static styles = {
    container: style({
      ...ModalChildStyle,
      position: 'relative',
      width: px(320),
      $nest: {
        '&> h3': {
          color: colorBrand.toString(),
          fontSize: px(30),
          margin: 0,
        },
        '&> p': {
          margin: '30px 0 20px 0',
        },
      },
    }),
    link: style({
      position: 'absolute',
      bottom: px(70),
      left: px(60),
      fontSize: px(12),
      color: colorBrand.toString(),
      $nest: {
        ...resetAnchorStyles(colorBrand.toString()),
      },
    }),
    switchLink: style({
      margin: important(0),
      backgroundColor: rgb(239, 239, 239).toHexString(),
      padding: px(16),
      borderRadius: px(16),
      marginTop: '16px !important',
    }),
  };
}
